import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import OtpInput from 'react-otp-input';
import InputField from '../../Common/InputField';
import { FaGoogle } from 'react-icons/fa';
import FullScreenLoader from '../Loader/FullScreenLoader';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { toast } from 'react-toastify';
import Navbar from '../Navbar/navbar';
import Footer from '../Footer/index';
import {
  removeUserOp,
  userLoginGenOp,
  userLoginVerifyOp,
} from '../../redux/operations/user.operations';
import { ipLookup, setUser } from '../../redux/actions/login.action';
import { GET_IP_ADDRESS } from '../../apiConst';
// import LanguageSelector from '../../Common/LangauageSelector';

const RESEND_OTP_TIME = 60; // seconds

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [otpFieldDisplay, setOtpFieldDisplay] = useState(false);
  const [googleUser, setGoogleUser] = useState([]);
  const [profile, setProfile] = useState(null);
  const [OTP, setOTP] = useState('');
  const [role, setRole] = useState(null);

  const [resendTimer, setResendTimer] = useState(0);
  const timerRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (value) => setOTP(value);

  // Timer countdown for resend OTP
  useEffect(() => {
    if (resendTimer === 0) {
      clearInterval(timerRef.current);
    }
  }, [resendTimer]);

  // Start timer helper
  const startResendTimer = () => {
    setResendTimer(RESEND_OTP_TIME);
    timerRef.current = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (googleUser && googleUser.access_token) {
      setIsLoading(true);
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${googleUser.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${googleUser.access_token}`,
              Accept: 'application/json',
            },
          }
        )
        .then((res) => {
          setIsLoading(false);
          setProfile(res.data);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    }
  }, [googleUser]);

  useEffect(() => {
    if (profile) {
      const data = { email: profile.email };
      loginViaEmailAndOTP(data);
    }
  }, [profile]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});

  useEffect(() => {
    if (
      localStorage.getItem('userAuthToken') &&
      (role === 'Grievance-Data-Entry-Operator' ||
        role === 'Grievance-Manager-Access')
    ) {
      navigate('/gms');
    } else if (
      localStorage.getItem('userAuthToken') &&
      role === 'Web-Portal-Data-Entry'
    ) {
      navigate('/news');
    } else if (
      localStorage.getItem('userAuthToken') &&
      role !== 'Grievance-Data-Entry-Operator'
    ) {
      navigate('/dashboard');
    } else {
      navigate('/seva-login');
    }
  }, [role]);

  const loginViaEmailAndOTP = (data) => {
    if (otpFieldDisplay) {
      data = { ...data, email };
      dispatch(removeUserOp()).then(() => {
        dispatch(userLoginVerifyOp(data))
          .then((res) => {
            dispatch(setUser(res.data.data));
            reset();
            toast.success(res.data.message);
            const { token } = res.data.data;
            if (token) {
              localStorage.setItem('userAuthToken', token);
              setRole(res.data.data.role);
            }
            setIsLoading(false);
          })
          .then(async () => {
            const response = await fetch(`${GET_IP_ADDRESS}`);
            const data = await response.json();
            if (data && data?.ip) {
              dispatch(ipLookup(data.ip));
            }
          })
          .catch((err) => {
            setIsLoading(false);
            console.log('error', err);
            err.response?.data?.message &&
              toast.error(err.response.data.message);
          });
      });
    } else {
      setEmail(data.email);
      dispatch(userLoginGenOp(data))
        .then((response) => {
          setOtpFieldDisplay(true);
          reset();
          toast.info(response.data.message);
          setIsLoading(false);
          startResendTimer(); // start timer when OTP sent
        })
        .then(async () => {
          const response = await fetch(`${GET_IP_ADDRESS}`);
          const data = await response.json();
          if (data && data?.ip) {
            dispatch(ipLookup(data.ip));
          }
        })
        .catch((err) => {
          setIsLoading(false);
          err.data?.message && toast.error(err.data.message);
          console.log(err);
        });
    }
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLoading(true);
    loginViaEmailAndOTP(otpFieldDisplay ? { ...data, otp: OTP } : data);
  };

  const handleResendOtp = () => {
    if (resendTimer === 0) {
      setIsLoading(true);
      dispatch(userLoginGenOp({ email }))
        .then((response) => {
          toast.info('OTP resent successfully.');
          reset();
          setIsLoading(false);
          startResendTimer();
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error('Failed to resend OTP. Please try again.');
        });
    }
  };

  const handleBackToEmail = () => {
    setOtpFieldDisplay(false);
    setOTP('');
    setResendTimer(0);
    clearInterval(timerRef.current);
  };

  const loginToGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => setGoogleUser(codeResponse),
    onError: (error) => console.log('Login Failed:', error),
  });

  return (
    <>
      <section className="h-screen">
        {isLoading && <FullScreenLoader />}
        {/* <LanguageSelector /> */}
        <Navbar />
        <div
          className="flex items-center justify-center bg-blue-100 md:pl-20 md:pr-20 pl-5 pr-5"
          style={{
            width: '100%',
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >
          <div className="flex flex-col lg:grid lg:grid-cols-2 lg:gap-4 justify-center items-center gap-2">
            <div className="flex flex-col justify-center">
              <h1 className="text-blueBg font-marcellus text-lg lg:text-2xl">
                Welcome to the SEVA Portal
              </h1>
              <br />
              <h2 className="text-blueBg text-justify font-marcellus text-sm md:text-md lg:text-xl">
                - SEVA is a platform for managing and resolving grievances,
                allowing users to submit, track, and receive updates on their
                concerns with transparency and professionalism. - Your voice
                matters at SEVA.
              </h2>
            </div>
            <div className="w-full sm:w-full h-auto min-h-screen-3/4 max-h-screen-3/4 rounded-xl px-5 py-20 mb-4 bg-white shadow-lg">
              {otpFieldDisplay ? (
                <>
                  <div className="mb-4 flex justify-between items-center">
                    <h1 className="text-2xl text-blueBg text-start font-montsettat md:text-center md:mr-36 font-bold">
                      Enter OTP
                    </h1>
                    <button
                      type="button"
                      onClick={handleBackToEmail}
                      className="font-montsettat text-sm text-blueBg underline hover:no-underline p-2"
                    >
                      Change Email
                    </button>
                  </div>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-6 flex justify-center">
                      <OtpInput
                        value={OTP}
                        onChange={handleChange}
                        numInputs={4}
                        inputType="tel"
                        name="otp"
                        renderSeparator={<span></span>}
                        inputStyle="inputStyle"
                        shouldAutoFocus={true}
                        renderInput={(props) => <input {...props} required />}
                      />
                    </div>
                    <div className="flex flex-col items-center">
                      <button
                        type="submit"
                        className="w-full md:w-1/2 font-montsettat max-w-sm mb-3 rounded-xl bg-blueBg px-7 pt-3 pb-2.5 text-sm font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out hover:bg-blue-700 focus:outline-none"
                      >
                        Verify OTP
                      </button>
                      <button
                        type="button"
                        onClick={handleResendOtp}
                        disabled={resendTimer > 0}
                        className={`w-full md:w-1/2 max-w-sm rounded-xl px-7 pt-3 pb-2.5 text-sm font-medium uppercase leading-normal shadow transition duration-150 ease-in-out ${
                          resendTimer > 0
                            ? 'bg-gray-400 text-gray-700 hover:bg-gray-700 cursor-not-allowed'
                            : 'bg-blueBg text-white hover:bg-blue-700'
                        }`}
                      >
                        {resendTimer > 0
                          ? `Resend OTP in ${resendTimer}s`
                          : 'Resend OTP'}
                      </button>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <h1 className="text-2xl text-blueBg font-montsettat font-bold mb-4 text-start">
                    Login With OTP
                  </h1>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="relative mb-6">
                      <InputField
                        fieldName="email"
                        register={register}
                        errors={errors}
                        validationObj={{
                          required: 'Please Enter Email',
                          pattern: {
                            value:
                              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            message: 'Please enter a valid email',
                          },
                        }}
                        fieldType="email"
                        className="min-h-[auto] w-full rounded-xl border-1 bg-transparent py-[0.32rem] px-3 leading-[2.15] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none"
                        placeholder="Email or Phone Number"
                      />
                    </div>
                    <div className="w-full flex flex-col items-center justify-center pb-3">
                      <button
                        type="submit"
                        className="w-full md:w-1/2 font-montsettat max-w-sm mb-3 inline-block rounded-xl bg-blueBg px-7 pt-3 pb-2.5 text-sm font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out hover:bg-blue-700 focus:outline-none"
                        data-te-ripple-init
                        data-te-ripple-color="light"
                      >
                        Sign in
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
